import { Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild ,Injector} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export const INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide:NG_VALUE_ACCESSOR,
  useExisting: forwardRef(()=> OpenSelectComponent),
  multi: true
};

@Component({
  selector: 'app-open-select',
  templateUrl: './open-select.component.html',
  styleUrls: ['./open-select.component.css'],
  providers: [INPUT_CONTROL_VALUE_ACCESSOR]
})
export class OpenSelectComponent implements OnInit,ControlValueAccessor {

  @Input() key:number;
  @Input() multiple: boolean = false;
  @Input() placeholder: string = '';
  @Input() DefaultFirst = false;
  @Output() onSelectedChange: EventEmitter<any> = new EventEmitter();
  @Output() onItemChange: EventEmitter<any> = new EventEmitter();
  @Input() disabled: boolean = false;
  @ViewChild('select', {static:true}) select : any;

  nullvalue = null;
  private _items: any[];
  @Input() get items(): any[]{
    return this._items;
  }

  set items(v:any[]){
    this._items = v;
    this.value = this.innerValue;
  }
  @Input() get selectedValue():any{
    return this.selectValue;
  }

  set selectedValue(v:any){
    this.selectValue = v;
    this.value = v;
    this.writeValue(this.selectValue);
  }

  public onTouchedCallback: ()=> void = () => {};
  public onChangeCallback: (_: any)=> void = (_: any) => {};

  get value(): any | any[]{
    if(!this.innerValue && this.multiple)
    {
      this.innerValue = [];
    }
    return this.innerValue;
  }

  set value(v: any | any[]){
    if(v !== this.innerValue)
    {
      this.innerValue = v;
      if(!this.multiple)
      {
        this.innerValue = String(v);
      }else{
        this.innerValue = v;
      }
      this.onChangeCallback(this.innerValue);
    }
  }

  constructor(public injector: Injector) { 
    //super(injector);
  }

  public innerItems: any[] = [];
  public innerValue: any |any[];
  public selectValue: any |any[];
  ngOnInit(): void {
  }

  onChange($event: any){
    this.onSelectedChange.emit($event);
  }

  defaultSelectFirst(){
    let data = this.items.length > 0 ? this.items[0]:null;
    data && (this.value = data.key);
  }

  getItem(key:any){
    return this.items.find(s=>s.key == key);
  }

  writeValue(obj:any):void{
    if(obj !== this.innerValue)
    {
      this.innerValue = obj;
      setTimeout(() => {
        if(!this.multiple)
        {
          this.selectValue = String(obj);
        }else{
          if(obj)
          {
            this.selectValue = (<any[]>obj).map(s=>s.toString());
          }
        }
      }, 0);
    }
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }
  
  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
